// assets/custom-popup.js
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('custom-popup-overlay');
  if (!overlay) return;

  // Identificador único de esta sección/popup
  const sectionId = overlay.getAttribute('data-section-id') || 'default';
  const storageKey = `custom-popup-shown-${sectionId}`;

  // Si ya lo hemos mostrado antes, no hacemos nada
  if (localStorage.getItem(storageKey)) return;

  // 1) Mostrar tras el delay configurado
  const delaySec = parseInt(overlay.getAttribute('data-delay'), 10) || 0;
  setTimeout(() => {
    overlay.classList.remove('custom-popup--hidden');
    // Marcamos que ya se mostró para no volver a abrirlo
    localStorage.setItem(storageKey, 'true');
  }, delaySec * 1000);

  // 2) Cerrar al clicar en la "X"
  const closeBtn = overlay.querySelector('.custom-popup__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      overlay.classList.add('custom-popup--hidden');
    });
  }

  // 3) Cerrar al clicar en el botón de promociones y luego redirigir
  const promoBtn = overlay.querySelector('.custom-popup__button');
  if (promoBtn) {
    promoBtn.addEventListener('click', e => {
      e.preventDefault();
      overlay.classList.add('custom-popup--hidden');
      const url = promoBtn.getAttribute('href');
      if (url) window.location.href = url;
    });
  }

  // 4) Cerrar si se hace click fuera de la caja
  overlay.addEventListener('click', e => {
    if (e.target === overlay) {
      overlay.classList.add('custom-popup--hidden');
    }
  });
});
